import React, { useContext } from 'react';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { useNavigate } from 'react-router-dom';
import { SiteContext } from '../../../context/SiteContext';
import Links from '../../common/Widgets/Links';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PageAbsolutePath } from '../../../consts/Common';

const MotorInsuranceClaimPage = (): JSX.Element => {
  const navigate = useNavigate();

  const { site } = useContext(SiteContext);

  const { brand } = site;

  const { claimsNumber, glassHelplineNumber } = brand.brandPhoneNumbers;

  const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;

  const goBack = (): void => {
    navigate(PageAbsolutePath.Insurance.SiteMap);
  };

  return (
    <div>
      <Links
        id='back-link'
        title=''
        items={[{ to: '../sitemap', text: 'Back' }]}
        icon={chevronLeftComponent}
      />
      <h2>How to make a motor insurance claim</h2>
      <p>We&apos;re here to make the difficult times feel a lot easier.</p>
      <p className='bold'>
        Call our 24-hour claims helpline on{' '}
        <a className='in-text' href={`tel:${claimsNumber}`}>
          {claimsNumber}
        </a>
      </p>
      <p className='bold'>
        For 24-hour glass claims or glass repairs call{' '}
        <a className='in-text' href={`tel:${glassHelplineNumber}`}>
          {glassHelplineNumber}
        </a>
      </p>
      <p>
        If your car is stolen, vandalised or broken into, please contact the
        police and get a crime reference number before making your claim.
      </p>
      <hr />
      <h2>A few tips in the event of a claim</h2>
      <h4>Contact us as soon as possible</h4>
      <p>
        Call us from the scene or as soon as possible after any incident.
        Leaving it too late could affect how much we can help you.
      </p>
      <h4>Don't take the blame</h4>
      <p>
        We&apos;ll take care of the claim and investigate who was responsible.
      </p>
      <h4>Record all details</h4>
      <p>
        We will ask you what happened and who was involved. Please have details
        of other vehicles, drivers, passengers and witnesses.Photographs of the
        scene and cars will also be helpful.
      </p>
      <ButtonBack
        name='btnBack'
        text='Back'
        onClick={goBack}
        additionalClassNames='btn-back'
      />
    </div>
  );
};

export default MotorInsuranceClaimPage;
